import React from "react";
import Chart from "../../common/ApexChart";
import Loader from "../../common/Loader";
import allApi from "../../../../api/allApi";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocalization } from "../../localization/LocalizationContext";
import { useNetwork } from "../../common/networkContext";

function ClientDataExpandation() {
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId, selectedLocation } = useNetwork();
  const networkId = selectedNetworkId?.id ?? 6001;
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [ClientDataCategories, setClientDataCategories] = useState([]);
  const [ClientDataConsumptionDuration, setClientDataConsumptionDuration] =
    useState("24h");
  const [ClientSeries, setClientSeries] = useState([]);
  //const [networkId, setNetworkId] = useState("all");

  const getClientDataConsumption = async (duration,networkId) => {
    try {
      setLoading(true);
      const api = new allApi();
      const response = await api.getRequest(
        `api/wireless/clientDataConsumption?commandType=5&duration=${duration}&networkId=${networkId}`
      );

      const apiResponse = response?.response || [];

      if (!apiResponse.length) {
        setClientSeries([]);
        setClientDataCategories([]);
        return;
      }

      let fullRange = [];

      if (duration === "7d" || duration === "30d") {
        // DAILY RANGE
        const days = duration === "7d" ? 7 : 30;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        fullRange = Array.from({ length: days }, (_, i) => {
          const d = new Date(today);
          d.setDate(today.getDate() - (days - 1 - i));
          return d;
        });
      } else {
        // HOURLY RANGE (8h / 24h)
        const hours = duration === "8h" ? 8 : 24;

        const now = new Date();
        now.setMinutes(0, 0, 0);

        fullRange = Array.from({ length: hours }, (_, i) => {
          const d = new Date(now);
          d.setHours(now.getHours() - (hours - 1 - i));
          return d;
        });
      }

      const series = apiResponse.map((client) => {
        const consumptionMap = {};

        // Build map from API data
        (client.data || []).forEach((entry) => {
          if (entry.interval) {
            let normalizedKey;

            if (duration === "7d" || duration === "30d") {
              normalizedKey = entry.interval.split(" ")[0];
            } else {
              normalizedKey = entry.interval.replace(" ", "T").slice(0, 13);
            }

            consumptionMap[normalizedKey] = Number(entry.totalConsumption) || 0;
          }
        });

        // Fill missing hours/days with 0
        const filledData = fullRange.map((date) => {
          let key;

          if (duration === "7d" || duration === "30d") {
            key = date.toISOString().split("T")[0];
          } else {
            key = date.toISOString().slice(0, 13);
          }

          return {
            x: date.getTime(),
            y: consumptionMap[key] ?? 0,
          };
        });

        return {
          name: `SN: ${client.serialNumber || "Unknown"}`,
          data: filledData,
        };
      });

      // 🔥 THIS WAS MISSING
      setClientSeries(series);
      setClientDataCategories(fullRange.map((d) => d.getTime()));
    } catch (error) {
      console.error("Error fetching client data:", error);
      setClientSeries([]);
      setClientDataCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const clientDataConsumptionOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: "datetime",
      tickAmount: 6,
      labels: {
        formatter: (value) => {
          const date = new Date(value);

          if (
            ClientDataConsumptionDuration === "7d" ||
            ClientDataConsumptionDuration === "30d"
          ) {
            const options = {
              day: "2-digit",
              month: "short",
              timeZone: "Asia/Kolkata",
            };
            return date.toLocaleString("en-IN", options);
          } else {
            const options = {
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "Asia/Kolkata",
              hour12: false,
            };
            return date.toLocaleString("en-IN", options);
          }
        },
        style: {
          colors: "#9aa0ac",
          fontSize: "12px",
        },
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: function (val) {
          return val !== undefined && val !== null ? val.toFixed(0) : "0 bytes";
        },
      },
      title: {
        text: "Data Consumption (bytes)",
      },
    },
    stroke: {
      width: 1,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      showForSingleSeries: true,
      labels: {
        colors: "#9aa0ac",
        fontSize: "12px",
      }, // Display legend for each series
    },
    colors: ClientSeries.map((_, index) =>
      index === 0 ? "#fc7594" : "#00aaff"
    ),
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  };

  useEffect(() => {
    getClientDataConsumption(ClientDataConsumptionDuration,networkId);
  }, [ClientDataConsumptionDuration,networkId]);

  const handleClientDataConsumptionDurationChange = (
    ClientDataConsumptionDuration
  ) => {
    setClientDataConsumptionDuration(ClientDataConsumptionDuration);
  };
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="inc-card ch-100">
          <div className="inc-card-title">
            <h3>{localizationStrings?.clientDataConsumption}</h3>
            <div className="card-title-dropdown">
              {/* <div className="btn-group">
                <span
                  className="dropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    {localizationStrings?.all}
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <a className="dropdown-item" href="#">
                        2.4 GHz
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        5 GHz
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        6 GHz
                      </a>
                    </li>
                  </ul>
                </span>
              </div> */}
              <div className="btn-group">
                <span
                  className="dropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    {ClientDataConsumptionDuration === "24h"
                      ? localizationStrings?.last24Hours
                      : ClientDataConsumptionDuration}
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          handleClientDataConsumptionDurationChange("8h")
                        }
                      >
                        {localizationStrings?.last8Hours}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          handleClientDataConsumptionDurationChange("24h")
                        }
                      >
                        {localizationStrings?.last24Hours}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          handleClientDataConsumptionDurationChange("7d")
                        }
                      >
                        {localizationStrings?.last7Days}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          handleClientDataConsumptionDurationChange("30d")
                        }
                      >
                        {localizationStrings?.last30Days}
                      </a>
                    </li>
                  </ul>
                </span>
              </div>
              <button
                className="icon-btn"
                title="Refresh"
                onClick={() =>
                  getClientDataConsumption(ClientDataConsumptionDuration,networkId)
                }
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div className="inc-card-body">
            <div className="row">
              <div className="col-lg-8">
                {loading ? (
                  <Loader />
                ) : (
                  <div>
                    {ClientSeries.length === 0 ? (
                      <div className="no-data-box">
                        <div className="no-data-text">
                          {localizationStrings?.noData}
                        </div>
                      </div>
                    ) : (
                      <Chart
                        options={clientDataConsumptionOptions}
                        series={ClientSeries}
                        type="line"
                        height={170}
                      />
                    )}
                  </div>
                )}
              </div>
              <div className="col-lg-4">
                <div className="round-border">
                  <div className="inc-card-table">
                    <table className="m-head">
                      <thead>
                        <tr>
                          <th>{localizationStrings?.serialNumber}</th>
                          <th>{localizationStrings?.dataConsumption}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ClientSeries &&
                          ClientSeries.length > 0 &&
                          ClientSeries.map((seriesItem, index) => {
                            const serialNumber = seriesItem.name.replace(
                              "SN: ",
                              ""
                            ); // Extract the serial number from the 'name'

                            // Calculate total consumption by summing over the 'y' values in the data array
                            const totalConsumption = seriesItem.data.reduce(
                              (total, item) => total + item.y,
                              0
                            );

                            return (
                              <tr key={index}>
                                <td>{serialNumber}</td>{" "}
                                {/* Display the serial number */}
                                <td>{totalConsumption.toFixed(2)} </td>{" "}
                                {/* Display the total consumption */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientDataExpandation;
